import React, {useContext, useEffect, useState} from 'react';
import { Course, UserRole } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { NecttosContext } from '../../../context/NecttosContext';
import { formatDate } from '../../utilities';
import Assignment from '../Dashboard/dashboardAssignment';



interface AllContentViewProps {
	course: Course;
	userRole: UserRole;
	selectedModule: string;
  onViewAssignment?: (assignment: any) => void;
}

const AllContentView: React.FC<AllContentViewProps> = ({ 
  course, 
  userRole, 
  selectedModule,
  onViewAssignment 
}) => {
  // Mock consolidated content data
  const {collegeId} = useContext(NecttosContext)
  const [allContent, setAllContent] = useState<any[]>([])



//   useEffect(() => {
//   const loadData = async () => {
//     const instance = await getAxiosTokenInstance();
//     try {
//       // MOCK DATA START
//       const mockData = {
//         data: [
//           {
//             _id: '1',
//             moduleId: 'module1',
//             title: 'Assignment 1',
//             type: 'assignment',
//             description: 'Complete the React project.',
//             dueDate: '2025-07-10',
//             status: 'Pending'
//           },
//           {
//             _id: '2',
//             moduleId: 'module2',
//             title: 'Quiz 1',
//             type: 'quiz',
//             description: 'Topics: React Hooks',
//             dueDate: '2025-07-12',
//             status: 'Available'
//           },
//           {
//             _id: '3',
//             moduleId: 'module1',
//             title: 'Lecture Notes',
//             type: 'material',
//             description: 'Notes for React Basics',
//             uploadDate: '2025-06-25',
//             status: 'Uploaded'
//           },
//           {
//             _id: '4',
//             moduleId: 'module3',
//             title: 'Announcement: Exam Date',
//             type: 'announcement',
//             description: 'Final exam will be held on August 10th.',
//             date: '2025-06-20',
//             status: 'Posted'
//           },
//           {
//             _id: '5',
//             moduleId: 'module1',
//             title: 'Assignment 2',
//             type: 'assignment',
//             description: 'Build a Todo App.',
//             dueDate: '2025-07-15',
//             status: 'Submitted'
//           }
//         ]
//       };
//       const resp = { data: mockData };

//       if (resp?.data) {
//         if (selectedModule !== 'all') {
//           const filteredContent = resp.data.data.filter((content: any) => content.moduleId === selectedModule);
//           setAllContent(filteredContent);
//         } else {
//           setAllContent(resp.data.data);
//         }
//       }
//       // MOCK DATA END
//     } catch (err) {
//       console.error("Error loading data:", err);
//     }
//   };

//   loadData();
// }, [userRole, course, selectedModule]);

    useEffect(() => {
      console.log(course);
  const loadData = async () => {
    const instance = await getAxiosTokenInstance();
    try {
      let resp;
      if (userRole === 'teacher') {
         resp = await instance.get(`/college/lms/all/getAllContentTeachers`,{
          params: {
            collegeId,
            totalStudents: course.count,
            subjectId: course.subjectId,
          }
          });
     if( resp?.data){
      console.log(resp.data.data);
     }
          
      } else if (userRole === 'student') {
         resp = await instance.get(`/college/lms/all/getAllContentsStudents`, {
          params: {
            studentId: 'NST-24CC30EF1B6F-4CA8-A416-0C79605B15DB',
            collegeId,
            totalStudents: course.count,
            subjectId: course.subjectId,
          }
         });
      }

      if (resp?.data) {
        console.log(resp.data.data)
        // Check if selectedModule is not 'all'
        if (selectedModule !== 'all') {
          const filteredContent = resp.data.data.filter((content: any) => {
            // Make sure to return true or false based on the condition
            return content.moduleId === selectedModule;
          });
          setAllContent(filteredContent); // Set the filtered content
        } else {
          setAllContent(resp.data.data); // If selectedModule is 'all', show all content
        }
      }

    } catch (err) {
      console.error("Error loading data:", err); // Log error for debugging
    }
  };

  loadData();
}, [userRole, course, selectedModule]); // Ensure to include selectedModule as a dependency

  
  // ].filter(item => selectedModule === 'all' || item.moduleId === selectedModule || item.moduleId === 'all');

  const getStatusBadge = (status: string, type: string) => {
    const baseClasses = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
    
    if (type === 'assignment' || type === 'quiz') {
      switch (status) {
        case 'Pending':
          return `${baseClasses} bg-yellow-100 text-yellow-800`;
        case 'Submitted':
          return `${baseClasses} bg-green-100 text-green-800`;
        case 'Available':
          return `${baseClasses} bg-blue-100 text-blue-800`;
        default:
          return `${baseClasses} bg-gray-100 text-gray-800`;
      }
    }
    return `${baseClasses} bg-gray-100 text-gray-800`;
  };

type ContentType = 'quiz' | 'assignment' | 'announcement' | 'glossary' | 'material';

const icons: Record<ContentType, string> = {
  quiz: '📝',
  assignment: '📚',
  announcement: '📢',
  glossary: '📖',
  material: '📂'
};


    

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <h2 className="text-xl font-semibold">All Content</h2>
        <div className="text-sm text-gray-500">
          Showing {allContent.length} items
        </div>
      </div>

      <div className="space-y-4">
        {allContent?.map((assignment) => (
          <div
            key={`${assignment.type}-${assignment._id}`}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-2xl">{icons[assignment.type as ContentType]}</span>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                      {assignment.title}{assignment.term}
                    </h3>
                    <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                      {assignment.type}
                    </span>
                  </div>
                </div>
                
                <p className="text-gray-600 dark:text-gray-400 mb-3">
                  {assignment.description}{assignment.definition}
                <p className="text-gray-600 dark:text-gray-400 mb-3">
                  {assignment.message}
                </p>
                </p>
                
                <div className="flex items-center gap-4 text-sm text-gray-500">
                  {assignment.type == 'assignment' && (
                    <span>Due: {formatDate(assignment.dueDate)}</span>
                  )}
                  {assignment.type == 'quiz' && (
                    <span>Due: {formatDate(assignment.endDate)}</span>
                  )}
                  {assignment.type == 'material' && (
                    <span>Uploaded: {formatDate(assignment.createdAt)}</span>
                  )}
                  {assignment.type == 'glossary' && (
                    <span>Uploaded: {formatDate(assignment.createdAt)}</span>
                  )}
                  {assignment.type == 'announcement' &&  (
                    <span>Posted: {formatDate(assignment.createdAt)}</span>
                  )}
                </div>
              </div>
              
              <div className="flex flex-col items-end gap-2">
                {(assignment.type == 'assignment' || assignment.type == 'quiz') && (
  <span className={getStatusBadge(assignment.status, assignment.type)}>
    {assignment.isSubmitted ? 'Submitted' : 'Pending'}
  </span>
)}

                { (assignment.type == 'assignment' || assignment.type == 'quiz' || assignment.type == 'announcement' || assignment.type == 'material') ?(
                <button className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100"  onClick={() => onViewAssignment?.(assignment)}>
                  View Details
                </button>):(
                <button className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100">
                  View Details
                </button>)}
              </div>
            </div>
          </div>
        ))}
      </div>
      {allContent.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">-</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No Contents found
          </h3>
          <p className="text-gray-500">
            No contents available for the selected module.
          </p>
        </div>
      )}
    </div>
  );
};

export default AllContentView;
